// extracted by mini-css-extract-plugin
export default {"button":"PopupButton_button__yq1G9","primary":"PopupButton_primary__ia+a9","secondary":"PopupButton_secondary__mq7Rh"};